import * as React from 'react';
import moment from 'moment-timezone';

/* Shared vocabulary for production pages (see mocks/production-*.html). */

export const STATUS_LABELS: Record<string, string> = {
    pending: 'Pending',
    ready_for_production: 'Ready for production',
    in_production: 'In production',
    show_ready: 'Show ready',
    past: 'Past',
    wrapped: 'Wrapped',
    lost: 'Lost',
};

const STATUS_CHIP_CLASSES: Record<string, string> = {
    pending: 'bg-sunk text-muted-foreground border-[1.5px] border-dashed border-off',
    ready_for_production: 'bg-brand-soft text-brand-ink',
    in_production: 'bg-good-soft text-good',
    show_ready: 'bg-good text-white',
    past: 'bg-sunk text-faint',
    wrapped: 'bg-sunk text-faint',
    lost: 'border border-attention/40 text-attention',
};

export function StatusChip({ status }: { status: string }) {
    return (
        <span
            className={
                'inline-flex h-[22px] flex-none items-center rounded-full px-2.5 text-[10.5px] font-semibold ' +
                (STATUS_CHIP_CLASSES[status] ?? 'bg-sunk text-muted-foreground')
            }
        >
            {STATUS_LABELS[status] ?? status}
        </span>
    );
}

export function DateChip({
    date,
    tbd,
}: {
    date?: string | null;
    tbd?: boolean;
}) {
    const m = date ? moment(date) : null;
    return (
        <span
            className={
                'w-[52px] flex-none rounded-[9px] py-1.5 text-center ' +
                (tbd || !m
                    ? 'border-[1.5px] border-dashed border-border'
                    : 'bg-secondary')
            }
        >
            <span className="ps-label block">{m ? m.format('MMM') : '—'}</span>
            <span
                className={
                    'mt-px block text-[14.5px] font-semibold ' +
                    (tbd || !m ? 'text-faint' : '')
                }
            >
                {m ? m.format('D') : ''}
            </span>
        </span>
    );
}

export function formatEventType(eventType?: string | null): string {
    if (!eventType) return '—';
    return eventType.replaceAll('_', ' ');
}

export function fullName(row: {
    firstName?: string;
    lastName?: string;
}): string {
    return [row.firstName, row.lastName].filter(Boolean).join(' ');
}
